var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import li from 'parse-link-header';
import * as Constants from './Constants';
import nonenumerable from './helpers/nonenumerable';
export class ResponseWrapper {
    constructor(requestedUri, res) {
        this.xhr = res;
        this.requestedUri = requestedUri;
    }
    get status() {
        return this.xhr.status;
    }
    get apiDocumentationLink() {
        if (this.xhr.headers.has(Constants.Headers.Link)) {
            const linkHeaders = this.xhr.headers.get(Constants.Headers.Link);
            const links = li(linkHeaders);
            if (links[Constants.Core.Vocab('apiDocumentation')]) {
                const linkUrl = links[Constants.Core.Vocab('apiDocumentation')].url;
                return this.resolveUri(linkUrl);
            }
        }
        return null;
    }
    get mediaType() {
        return this.xhr.headers.get(Constants.Headers.ContentType) || Constants.MediaTypes.jsonLd;
    }
    get redirectUrl() {
        if (this.xhr.redirected) {
            return this.xhr.url;
        }
        return null;
    }
    resolveUri(uri) {
        return new URL(uri, this.redirectUrl || this.requestedUri).toString();
    }
}
__decorate([
    nonenumerable,
    __metadata("design:type", Response)
], ResponseWrapper.prototype, "xhr", void 0);
//# sourceMappingURL=ResponseWrapper.js.map